import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Home = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(
      "https://shreyas-dobby-backend-production.up.railway.app/api/getImage/getData"
    )
      .then((res) => {
        // console.log(res);
        return res.json();
      })
      .then((result) => {
        // console.log(result);
        setData(result.allData);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div>
      <div className="text-3xl flex justify-center items-center mb-4 p-5">
        Uplaod any image you like and enjoy!
      </div>
      <div className="flex justify-center items-center text-xl p-8">
        <Link
          to={localStorage.getItem("token") ? "/imageupload" : "/login"}
          className="p-2 bg-blue-800 text-white rounded-md"
        >
          Upload Image
        </Link>
      </div>

      <div className="flex justify-center items-start p-2">
        <div className="space-x-2">
          <input
            type="text"
            name="search"
            placeholder="search...."
            className="p-1 rounded mb-10 outline-none border-2 border-black focus:border-blue-800 
            focus:ring-2"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
      </div>

      {loading ? (
        <p className="p-5 flex justify-center items-center text-lg">
          Loading.....
        </p>
      ) : (
        data
          .filter((name) =>
            name.name.toLowerCase().includes(search.toLowerCase())
          )
          .map((singleData) => {
            // console.log(singleData);
            const base64String = btoa(
              new Uint8Array(singleData.image.data.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
            return (
              <div
                key={Math.random()}
                className="flex flex-col justify-center items-center bg-gray-100 p-5 w-full"
              >
                {/* <div className="flex flex-col"> */}
                <img
                  src={`data:image;base64, ${base64String}`}
                  alt=""
                  className="rounded-md w-[40%]"
                />
                {/* </div> */}
                <p className="text-xl p-1">{singleData.name}</p>
              </div>
            );
          })
      )}
    </div>
  );
};

export default Home;
